export function normalizeApplicationStatusKey(raw) {
	return String(raw || 'not_started')
		.trim()
		.toLowerCase()
		.replace(/\s+/g, '_')
		.replace(/-/g, '_')
}

const TITLE_SUFFIX = {
	not_started: 'Not Started',
	in_progress: 'In Progress',
	ready_to_apply: 'Ready to Apply',
	submitted: 'Submitted',
	accepted: 'Accepted',
	waitlisted: 'Waitlisted',
	rejected: 'Rejected',
}

export function applicationStatusTitle(status) {
	const key = normalizeApplicationStatusKey(status)
	const suffix = TITLE_SUFFIX[key] || TITLE_SUFFIX.not_started
	return suffix
}

/** CSS module modifier: submittedBtn_status_<key> */
export function applicationStatusModifierClass(status) {
	const key = normalizeApplicationStatusKey(status)
	const safe = /^[a-z0-9_]+$/.test(key) ? key : 'not_started'
	return `status_${safe}`
}

export const COUNSELOR_STATUS_OPTIONS = [
	{ value: 'not_started', menuLabel: 'NOT STARTED' },
	{ value: 'in_progress', menuLabel: 'IN PROGRESS' },
	{ value: 'ready_to_apply', menuLabel: 'READY TO APPLY' },
	{ value: 'submitted', menuLabel: 'SUBMITTED' },
	{ value: 'accepted', menuLabel: 'ACCEPTED' },
	{ value: 'waitlisted', menuLabel: 'WAITLISTED' },
	{ value: 'rejected', menuLabel: 'REJECTED' },
]

export const STATUS_APPLICATION_FROM_API = [
	'not_started',
	'in_progress',
	'ready_to_apply',
	'submitted',
	'accepted',
	'waitlisted',
	'rejected',
]

export const APPLICATION_ROADMAP_STATUSES = STATUS_APPLICATION_FROM_API.map(id => ({
	id,
	label: applicationStatusTitle(id),
}))

export const STATUS_ESSAY_FROM_API = [
	'submitted_for_review',
	'draft_only',
	'draft',
	'approved',
	'revision_requested',
	'updating',
]
